import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { create } from 'kts-scaffold-framework/utils/form';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Form, Select, Input, Modal } from 'antd';

const css = require('./index.scss');
const { TextArea } = Input;
/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class AuthRecordFilter extends UIBasic<any, ModulesState> {
    /**
     * 
     * @param {*拒绝填写原因} props 
     */
    constructor(props: any) {
        super(props, ModulesAction);
        this.state = {
            content: this.props.content
        };
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.refush(values.refusedReason);
            }
        });
    }
    onCloseModal = () => {
        this.props.onCloseModal();
    }
    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <div>
                <Modal
                    title="拒绝原因"
                    visible={true}
                    onCancel={this.onCloseModal}
                    onOk={this.handleSubmit}
                >
                    <p>{this.props.content}</p>
                    <Form layout={'horizontal'}>
                        {getFieldDecorator('refusedReason')(
                            <TextArea placeholder="内容不要超过128个字符" rows={4} maxLength={128} />
                        )}
                    </Form>
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/OutputSettlement/UI.Refuse.tsx